// src/data/congratulatoryMessages.js

export const professors = [
  {
    name: '강지헌',
    image: '/images/kang.jpeg',
    message: `제3회 소프트웨어전공 졸업작품전시회를 진심으로 축하합니다. 이 졸업작품전시회가 열리 수 있도록 1년간 너무나 고생해준 우리 소프트웨어전공 제1/2 전공생들의 9개 팀에게 너무나 감사합니다. 여러분이 만들어낸 작품들이 잘 전시될 수 있도록 방학 중 신경써준 다혜, 소정이 그리고 조교님께도 감사드려요.

매년 졸업전시회를 위한 캡스톤디자인을 한 라운드 씩을 돌아아가는 걸 지켜보면, 무엇을 해야 할지 어리둥절로 회의를 시작해서 이게 되네!로 마무리되는 경우를 많이 봐왔어요.
여러분도 입학한지 엊그제 같은데 이제 마지막 학기라고? 시간이 왜 이리 빨리 지난 거지? 놀라고들 있죠? 걱정 마세요 앞으로 시간이 더 빨리 지나갈 거에요 ^^

이제 우리 전공생들은 졸업요건은 거의 갖추셨을 거고... 진짜 졸업할 준비들은 다 되셨는지요? 현재 학과장 역할을 담당하고 있다 보니 휴학,  졸업유예, 취업률 등이 지표를 보면 우리 학생들이 취업 빙하기를 살고 있구나 하는 생각에 나름 사회선배로서 미안하고 염려스럽습니다. ㅠㅠ

하고싶은 말은 많지만 제가 여러분을 위해 할 수 있는 것 먼저 할께요. 전 기독교, 천주교, 불교 다 믿어요.  하루에 세번 메카를 향해 절도 할 수 있습니다.^^ 평소엔 성당, 고향 가서는 교회, 등산이나 여행 다닐 땐 사찰은 꼭 들리니 어느 곳에서든 기도든 공양이든 여러 수단으로 여러분의 남은 학창시절과 사회에서 덕성인으로 살아갈 멋진 날을 응원하겠습니다.

다시 한 번 졸업작품전시회를 풍성하게 만들어준 학생들에게 감사드립니다.

- 더위가 살짝 꺾이고 있는 어느 여름날 바다에서 씀^^ -
`,
  },
  {
    name: '음두헌',
    image: '/images/eum.png',
    message: `안녕하세요. 졸업작품 전시회를 진심으로 축하드립니다.

캡스톤 발표를 통해, 교수님들의 열정적인 지도와 여러분의 끈기 있는 노력이 빚어낸 훌륭한 작품들을 확인할 수 있었습니다. 방학 동안 더욱 정제된 여러분의 결과물을 전시회에서 마주할 수 있게 되길 기대합니다.

몇 년 전 방영된 ‘싱어게인’이라는 tv 프로그램의 열성 팬이었습니다. 이후, 우승자들의 전국투어에도 참석하고 싶었지만, 광클릭에 실패해서 많이 아쉬웠던 기억이 있습니다. 졸업 예정자 여러분은 지금, 사회라는 무대에서 ‘싱어게인’에 참가한 가수처럼 새로운 시작을 앞두고 있습니다. 많은 시간 동안 갈고닦은 실력과 용기를 모아 무대에 오를 이 순간은, 여러분의 노력과 열정이 관객과 처음 마주하는 순간이자 앞으로 펼쳐질 커리어의 첫 페이지입니다.

그리고 지금 우리는 AI 기술이 일상과 산업 곳곳에서 중심이 되는 시대를 살아가고 있습니다. 단순히 기술을 이해하는 것을 넘어, AI 비서를 능숙하게 활용하며 문제를 해결하고 창의적인 가치를 더할 수 있는 사람이야말로 진정한 전문가라 할 수 있습니다. 여러분이 바로 그런 전문가로 성장하길 기대합니다. 스스로에게 묻고, AI에게도 묻고, 그 대화 속에서 답을 찾아내는 미래형 인재가 되어주길 바랍니다.

오늘의 전시회가 그 가능성의 시작점이 되어, 여러분 모두가 자신의 무대에서 빛나는 프로로 성장하시길 진심으로 응원합니다.`,
  },
  {
    name: '이형규',
    image: '/images/hglee.jpeg',
    message: `소프트웨어전공 3기 여러분, 지난 4년간의 대학생활이 어느덧 끝을 향해 가고 있습니다. 지난 1년여간 졸업작품을 위해 쏟아 부은 열정과 노력이 값진 결실로 맺어진 졸업작품 전시회를 진심으로 축하하며, 그동안 함께 고생한 여러분 모두에게 아낌없는 박수를 보냅니다.

졸업작품은 단순히 학업의 마지막 과제가 아닙니다. 그것은 여러분이 대학에서 배우고 익힌 지식, 창의력, 그리고 끊임없는 문제 해결 노력이 집약된 결과물입니다. 또한, 많은 경우 팀원들과 함께 협업하며 이뤄낸 작업이기에, 소통과 협력의 중요성도 몸소 체험했을 것입니다. 서로의 강점을 이해하고 보완해가며 만들어낸 결과는 여러분의 실력 뿐 아니라 서로에 대한 배려를 통해 함께 일하는 자세까지 한층 더 성장시켰으리라 믿습니다.

과정이 쉽지 만은 않았겠지만, 어려운 상황 속에서도 끝까지 도전하고 완성해낸 여러분의 용기와 끈기는 매우 자랑스럽습니다. 작품이 완벽하든 그렇지 않든, 그 안에는 분명 여러분의 고민과 노력, 그리고 진심이 담겨 있습니다. 이 경험은 앞으로 여러분이 마주할 어떤 과제에도 소중한 자산이 될 것입니다.

이제 졸업이라는 큰 전환점을 앞두고 있습니다. 새로운 환경, 새로운 도전이 기다리고 있겠지만, 이번 졸업작품을 해낸 것처럼 앞으로도 무엇이든 해낼 수 있다는 자신감을 가지시기 바랍니다. 스스로를 믿고, 지금처럼 끊임없이 배우고 나아가길 바랍니다.

소프트웨어전공 3기 졸업생으로서, 여러분의 성장을 진심으로 응원하며, 미래에도 여러분이 원하는 꿈을 향해 힘차게 나아가길 기원합니다. 다시 한 번 졸업작품 전시회의 개최를 축하드리며, 여러분의 새로운 출발을 진심으로 응원합니다.

소프트웨어전공 3기 졸업생, 화이팅!
감사합니다.

`,
  },
  {
    name: '이재호',
    image: '/images/izeho.jpeg',
    message: `사랑하는 솦웨 마지막 학우 여러분,

솦웨의 처음과 마지막을 함께한 사람으로서, 저에게 솦웨는 정말 애정이 큽니다. 특히 마지막 식구 여러분은 저에게 큰 자랑거리입니다. 말랑말랑한 두뇌를 가지셨고 재치 있는 똘끼를 가지셨고 무한의 단체 에너지를 가지셨고 저는 못 가지셨고 강지헌은 가지신, 가장 기억에 남는 기수일 것 같아요. 

제 기억속의 솦웨 마지막 멤버는, 솔직하고 직선적이지만 깔끔하고 최고의 수업반응을 주시고 불의를 응징하고 착하기보단 실익을 따르고 아닌 건 아니라고 말하는..  정의롭고 열정 있고 똑똑한 쌉T형 기수입니다. 저와 많이 닮아서 좋습니다. 이렇게 멋진 졸업작품을 완성해 주셔서 대견하고 뿌듯합니다.

이제 곧 학교를 떠나십니다. 저와 곧 이별을 합니다. 슬퍼하지 마세요. 금방 잊어버리실 거 압니다. 우리 솦웨는 앞만 보고 달리는 현실생산형 인재니까요. 그래도 전 오래 기억하겠습니다. 추억은 저에게 남겨두시고, 미래를 위해 훨훨 날아가세요. 저는 그리워할 테니 여러분은 쿨하게 뛰세요. 그리고 가끔 업글된 자아를 자랑하러 놀러와주세요. 빈 손은 안됩니다. 저는, 여러분의 신화를 기억하고 후배들에게 자랑하겠습니다. 그러니, 항상 최선을 다하고 바른 마음을 가지고 근면하고 성실하고 착하고 좋은 사람 말고, 그냥 최고가 되세요. 갖고 싶으면 가지세요. 어울리게 사세요. 별거 아닙니다. 그냥 하던 대로 하시면 언젠간 됩니다. 인생은, 승률에 관계없이 그냥 한번만 성공하면 되는, 나름 개꿀 조건입니다. 로또와 같습니다.

여러분은 덕성여자대학교 소프트웨어전공의 마지막 기수라는 레코드를 가지고 있습니다. 여러분이 노력하시면 우리 소프트웨어전공은 신화가 됩니다. 후배들은 동경만 할 뿐 가질 수 없는 소프트웨어전공이 됩니다. 졸업 후 어떤 길을 가시더라도, 꿈을 꾸기보단 달성하는, 넘어질지 언정 울지 않는, 강력한 최강 솦웨 세계관의 전설적인 마지막 세대가 되시길 간곡히 부담 드리겠습니다. 사랑합니다~~

Complying to the greatest of the last SW legends,
이재호 올립니다.
`,
  },
  {
    name: '유제혁',
    image: '/images/ryu.png',
    message: `사랑하는 소프트웨어 전공 학우 여러분들. 

입학부터 졸업까지 긴 여정을 걸어온 여러분들에게 진심 어린 축하와 격려의 말씀을 전합니다. 지금까지의 시간은 단지 학점을 위한 과정이 아니라, 끊임없이 배우고 성장하며, 실질적인 문제를 해결할 수 있는 역량을 갖추어 온 시간이었다고 생각합니다.
 
여러분이 만들어 낸 졸업작품을 보며, 긴 시간 쌓아온 노력과 성장의 발자취를 다시금 되새기게 됩니다. 졸업을 위한 단순한 프로젝트가 아닌, 현실의 문제를 기술로 해결하고자 했던 여러분의 시도 하나하나가 더 큰 의미로 다가옴을 느낍니다. 

졸업 작품을 진행하는 동안, 마음처럼 계획했던 모든 것들이 한번에 잘 이루어 지지 않아 답답하기도 했을 것이고 어떤 날에는 무엇을 해야 할지, 어떻게 문제를 풀어야 할지 몰라 걱정만 앞서기도 했을 겁니다. 팀원들과 문제를 정의하고 해결해 나가는 과정 속에서, 여러분은 분명 성장했습니다. 지난 성공의 경험들처럼, 어떤 상황에서도 동료를 존중하고 배려하며 서로를 위하고, 때로는 큰 목표를 위한 선의의 경쟁을 통해 더욱 자신을 가꾸고 단단하게 만들어 가길 바랍니다.  

  여러분은 이제 대학교라는 작은 울타리에서 벗어나 더 넓은 세상으로 나아갈 준비가 되었습니다. 익숙했던 강의실을 떠나 낯설고 생소한 사회로 나아가겠지만, 이곳에서 쌓아온 지식과 경험, 그리고 학우들과 함께 나누었던 의미 있는 시간들은 언제나 여러분들을 지탱해줄 것입니다. 

이번 졸업작품전이 여러분 각자의 첫 발걸음을 기억하게 해주는 따뜻한 기록이 되길 바랍니다. 여러분이 나아갈 앞날에 아낌없는 지지와 응원을 보냅니다. 감사합니다. 
`,
  },
];
